import { generateUUID } from 'utils/uuid';

export default {
	_publish: function(eventName, ...args) {
		this.eventHandler.publish.call(this.eventHandler, eventName, ...args);
		return Promise.resolve();
	},

	onSetProperties: function(itemId, properties, trigger, callback) {
		this._setProperties(itemId, this.store[itemId], properties, trigger, callback)
	},

	_setProperties: function(itemId, model, properties, trigger) {
		return new Promise((resolve, reject) => {
		  	for (let property in properties) {
				model[property] = properties[property];
			}

			if (trigger) {
				this.trigger(this.store[itemId], resolve);
			} else {
				resolve();
			}
			return model;
		});
	},

	_getProperties: function(model, properties) {
		if (properties && properties.length && properties.length === 1) {
			return model[properties[0]];
		}
		let props = { }
		for (let cont = 0, len = properties.length; cont < len; cont++) {
			if (model.hasOwnProperty(properties[cont])) {
				props[properties[cont]] = model[properties[cont]];
			}
		}
		return props;
	},

	_getStoreItem: function(itemId) {
		return this.store[itemId];
	},

	onSetState: function(itemId, callback) {
		this.trigger(this.store[itemId], callback);
	}

}
